export const getUserMetaData = (state) => state.entities.users?.userMetaData || {};
